import api from "./api";
export const fetchUserRole = async () => {
    try {
      const res = await api.get(`/user/role/`);
      if (res.data?.role?.role) {
        return res.data.role.role;
      }
    } catch (error) {
      console.error("Error fetching role:", error);
    } 
  };